import { PRIVACY_HTML, PRIVACY_VERSION } from "@/content/legal/versions";

export default function PrivacyPage() {
  return (
    <div className="container mx-auto max-w-3xl px-4 py-12">
      <header className="mb-8">
        <h1 className="text-3xl font-bold">
          Política de Privacidad y Protección de Datos Personales
        </h1>
        <p className="text-sm text-muted-foreground">
          Versión {PRIVACY_VERSION} · Arcus Learn
        </p>
      </header>
      <article
        className="prose prose-sm max-w-none prose-headings:font-semibold prose-p:leading-relaxed"
        dangerouslySetInnerHTML={{ __html: PRIVACY_HTML }}
      />
    </div>
  );
}
